import { useState } from "react";
import { FaSignOutAlt, FaUsers, FaTable, FaUserPlus, FaPlusSquare, FaCog, FaChevronUp, FaChevronDown, FaImage } from "react-icons/fa";

import { FiMenu, FiX } from "react-icons/fi";
import SettingsModal from "./SettingsModal";
import { useDispatch, useSelector } from "react-redux";
import { loggOutUser } from "../store/userSlice";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DownloadGuestsPDFButton from "./DownloadGuestsPDFButton";

const NavbarOrganization = ({ activeForm, setActiveForm, guests, tables, hasReservations }) => {
    const { t, i18n } = useTranslation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [settingsInitialTab, setSettingsInitialTab] = useState("personal");
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const wedding = useSelector((state) => state.userStore.wedding);
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(loggOutUser());
        setShowLogoutConfirm(false);
    };

    const handleGuestsClick = () => {
        if (guests.length === 0) {
            setActiveForm("addGuest");
            setIsMobileMenuOpen(false);
        } else {
            setActiveForm("guests");
            setIsMobileMenuOpen(false);
        }
    };

    const handleTablesClick = () => {
        if (tables.length === 0) {
            setActiveForm("addTable");
            setIsMobileMenuOpen(false);
        } else {
            setActiveForm("tables");
            setIsMobileMenuOpen(false);
        }
    };

    const openSettings = (tab = "personal") => {
        setSettingsInitialTab(tab);
        setShowProfileModal(true);
        setIsMobileMenuOpen(false);
    };

    return (
        <nav className="lg:shadow-md bg-gradient-to-br from-cyan-100 via-cyan-50 to-pink-200 fixed w-full top-0 z-40 lg:hidden">
            <div className="mx-auto pl-2 pr-4 py-1 flex justify-between items-center">
                <Link to="/" className="flex justify-center items-center">
                    <img src="/logo2.png" className="w-10 h-10" alt="Weddinfy" />
                    <h1 className="font-display text-xl font-semibold text-gray-800">{t('appName')}</h1>
                </Link>
                <div className="flex items-center gap-4">
                    <button
                        className="lg:hidden text-gray-800 text-2xl"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                        {isMobileMenuOpen ? <FiX /> : <FiMenu />}
                    </button>
                </div>
            </div>

            <div className={`lg:hidden shadow-md transition-all duration-300 overflow-hidden ${isMobileMenuOpen
                ? 'max-h-[80vh]'
                : 'max-h-0'}`}>
                <div className="flex flex-col space-y-2 overflow-y-auto max-h-[80vh]">
                    <button disabled={!wedding} onClick={handleGuestsClick}
                        className={`flex items-center space-x-2 py-2 px-5 text-xl ${activeForm === "guests" ? "bg-blue-700 text-white" : ""}`}>
                        <FaUsers />
                        <span >{t('guests')}</span>
                        <span>{guests.length}</span>
                    </button>
                    <button disabled={!wedding} onClick={handleTablesClick}
                        className={`flex items-center space-x-2 py-2 px-5 text-xl ${activeForm === "tables" ? "bg-blue-700 text-white" : ""}`}>
                        <FaTable />
                        <span>{t('tables')}</span>
                        <span>{tables.length}</span>
                    </button>
                    <button disabled={!wedding} onClick={() => { setActiveForm("addGuest"); setIsMobileMenuOpen(false); }}
                        className={`flex items-center space-x-2 py-2 px-5 text-xl ${activeForm === "addGuest" ? "bg-blue-700 text-white" : ""}`}>
                        <FaUserPlus />
                        <span>{t('addGuest')}</span>
                    </button>
                    <button disabled={!wedding} onClick={() => { setActiveForm("addFamily"); setIsMobileMenuOpen(false); }}
                        className={`flex items-center space-x-2 py-2 px-5 text-xl ${activeForm === "addFamily" ? "bg-blue-700 text-white" : ""}`}>
                        <FaUsers />
                        <span>Dodaj obitelj</span>
                    </button>
                    <button disabled={!wedding} onClick={() => { setActiveForm("addTable"); setIsMobileMenuOpen(false); }}
                        className={`flex items-center space-x-2 py-2 px-5 text-xl ${activeForm === "addTable" ? "bg-blue-700 text-white" : ""}`}>
                        <FaPlusSquare />
                        <span>{t('addTable')}</span>
                    </button>
                    <button disabled={!wedding} onClick={() => openSettings("invitation")}
                        className="flex items-center space-x-2 py-2 px-5 text-xl disabled:opacity-50">
                        <FaImage />
                        <span>{t('tabInvitation')}</span>
                    </button>
                    <hr />
                    <button onClick={() => openSettings("personal")}
                        className="flex items-center space-x-2 py-2 px-5 text-xl">
                        <FaCog />
                        <span>{t('settings')}</span>
                    </button>
                    <button onClick={() => { setShowLogoutConfirm(true); setIsMobileMenuOpen(false); }}
                        className="text-red-600 hover:text-red-500 flex items-center space-x-2 py-2 px-5 text-xl">
                        <FaSignOutAlt />
                        <span>{t('logout')}</span>
                    </button>
                    <hr />
                    <div className={!hasReservations ? "pointer-events-none opacity-50" : ""}>
                        <DownloadGuestsPDFButton />
                    </div>
                    <hr />
                </div>
            </div>

            {showProfileModal && (
                <div className="">
                    <SettingsModal
                        onClose={() => setShowProfileModal(false)}
                        initialTab={settingsInitialTab}
                    />
                </div>
            )}

            {showLogoutConfirm && (
                <div className="fixed inset-0 p-4 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm text-center space-y-4">
                        <h3 className="text-lg font-semibold text-gray-800">
                            {t('logoutConfirmTitle')}
                        </h3>
                        <div className="flex justify-end space-x-2 mt-4">
                            <button
                                onClick={handleLogout}
                                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700 transition"
                            >
                                {t('logout')}
                            </button>
                            <button
                                onClick={() => setShowLogoutConfirm(false)}
                                className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition"
                            >
                                {t('cancel')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default NavbarOrganization;
